import greenStar from '../../assets/images/green-star.svg';

export const TrustPilotReviews = () => (
  <div className="reviews-section">
    <p>
      See our <span className="font-weight-bold">Excellent</span> reviews on
    </p>
    <div className="d-flex align-items-center font-weight-bold">
      <img src={greenStar} alt="Trustpilot star" width="14" className="mr-1" style={{ marginBottom: '2px' }} />
      <p>Trustpilot</p>
    </div>
  </div>
);
